import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

/**
 * Signals that a user tried to interact with a component while edit mode is off, so the report view
 * can flash the edit toggle to hint that edit mode must be re-enabled.
 */
@Injectable()
export class EditModeHintService {

    private _flash = new Subject<void>();
    readonly flash$: Observable<void> = this._flash.asObservable();

    requestEnable() {
        this._flash.next();
    }
}
